import { Component, OnInit, Inject, AfterViewInit, Input, OnChanges, SimpleChanges, OnDestroy, Output, EventEmitter, HostListener } from '@angular/core';
import { ConfirmDialogComponent } from './../../../../../common/components/confirm-dialog/confirm-dialog.component';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { NgbDateStruct, NgbCalendar, NgbDate, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { GrowerOrderService } from './../../../../../services/seed/growerOrder.service';
import { AccountVM } from './../../../../../models/AccountMasterVM';
import { GrowerOrderData } from './../../../../../models/GrowerOrderData';
import { ConfigService } from './../../../../../services/infrastructure/config.service';
import { GrowerOrderItemVM } from './../../../../../models/GrowerOrderItemVM';
import { SliderModelService } from './../../../../../services/infrastructure/sliderModel.service';
import { LoaderService } from './../../../../../services/infrastructure/loader.service';
import { LocalStorageService } from './../../../../../services/infrastructure/local-storage.service';
import { ToastrService } from 'ngx-toastr';
import { MasterConstants } from '../../../../../common/constants/master-constants';
import * as $ from 'jquery';
import { BroadcastService } from './../../../../../services/infrastructure/broadcaster.service';
import { DashboardFilter } from './../../../../../models/DashboardFilter';
import { CommonService } from '../../../../../services/common/common.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-addeditorderdetail',
  templateUrl: './add-edit-order.component.html',
  styleUrls: ['./add-edit-order.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})

export class AddEditOrderDetailComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() GrowerOrderObj: GrowerOrderData;
  @Input() GrowerOrderItemList: GrowerOrderItemVM[];
  @Input() AccountId: number;
  @Input() growerId: string;
  @Input('SelGrowerObj') SelGrowerObjInput: string;
  private subscription = new Array<Subscription>();

  errorMsgs = new Array();

  @Output() GetErrorMsgs = new EventEmitter();
  editToolKit = false;
  SelAccountObj: AccountVM;
  SelGrowerObj: GrowerOrderData;
  growerOrderId: string;
  growerOrderNumber: string;
  growerOrderDS: MatTableDataSource<any>;
  filterGrowerOrderDSitems: any[] = [];
  shortDate: any;
  title: string;
  message: string;
  model: NgbDateStruct;
  date: { year: number, month: number };
  productSearchFilter: string;
  tabNode: string;
  isDisabled = (date: NgbDate, current: { month: number }) => date.month !== current.month;
  isWeekend = (date: NgbDate) => this.calendar.getWeekday(date) >= 6;
  showAccInfo: Boolean = false;
  showGrowerInfo: Boolean = false;
  showProductDetails: Boolean;
  dealerOrderNumber = '';
  public partialSearchValue = '';
  // productMasterList: any = [];
  marketingMasterList: any = [];
  seedsizeMasterList: any = [];
  packagesizeMasterList: any = [];
  technologyMasterList: any = [];
  treatmentMasterList: any = [];
  maturityMasterList: any = [];
  productLineMasterList: any = [];
  filterValueList: any = [];
  searchValue = '';
  maxlength = 50;
  isUpdateAction = false;
  disablecheckbox = false;
  datemodel: NgbDateStruct;
  isIndeterminate = false;
  isAllChecked = false;
  public customerPONo: string;
  public selectedBillingType: string;
  public selectedGrowerToGrowerItemList = new Array();

  // edit fields : Start
  sellerData: any = null;
  selectedCount = 0;
  sellerId: string;
  enableAddProduct = true;
  isAddProductClick = false;
  bagCount = 0;
  growerOrderListCopy: any;
  productFilters: any;
  checkedItems: any = [];
  availabilityLostList: any = [];
  productList: any;
  disableOnLock = false;
  isBusy = false;
  isSearchClicked = false;
  buttonType = 'add';
  isInvalidEmail = false;
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  filteredDataCount = 0;
  activeCropYear: any;
  dateFilter: any;
  accountId = 0;
  hasChangeAdded = false;
  growerOrderDataCopy: any;
  isReadOnly = false;
  accessTypeMode = false;
  dataChangeSubscription: any;
  accountChangeSubscription: any;
  cutCancelCancellationMessage: string;
  growerGMK: number;
  selectedDealerAccount: number;
  hasUnlicensedItems = false;
  hasGrowerLicensePageAccess = false;
  licenseActionMessageHtml = '';
  // edit fields : End

  // Search Type set Up fro grid
  searchTypeList: any[] = [
    { name: 'Product Name', value: 'ProductNameFilter' },
    { name: 'Marketing Brand', value: 'marketingBrand' },
    { name: 'Seed Size', value: 'seedSize' },
    { name: 'Package Size', value: 'packageSize' },
    { name: 'Technology', value: 'technology' },
    { name: 'Treatment', value: 'treatment' },
    // { name: 'Maturity', value: 'maturity' },
    { name: 'Product Line', value: 'productLine' }
  ];

  // Names of column of grid
  // columnsToDisplay = ['checkbox', 'product', 'itemNumber', 'seedSize', 'treatment', 'packageSize', 'technology', 'dealerUnits', 'longShort', 'maturity', 'geu', 'delivery'];
  columnsToDisplay = ['checkbox', 'product', 'seedSize', 'treatment', 'packageSize', 'technology', 'dealerUnits', 'longShort', 'geu', 'delivery'];

  // internal
  expandedElement: any | null;
  decreasedItemList: any = [];
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  IsMobile = false;
  isInMobileApp = false;
  disabledHybridVariety = true;
  executeAccessApi = false;
  checkedAccountForAccess: any;
  hybridErrorToolTip: string;
  hybridVarietyProductLines: string;
  hybridVarietyMarketingBrands: string;

  constructor(private growerOrderService: GrowerOrderService,
    private localStorageService: LocalStorageService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private calendar: NgbCalendar,
    private configService: ConfigService,
    private toastrService: ToastrService,
    private router: Router,
    private loaderService: LoaderService,
    private sliderModelService: SliderModelService,
    public broadcastService: BroadcastService,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    public commonService: CommonService,
    @Inject('BASE_URL') public baseUrl: any) {
    this.model = this.calendar.getToday();
    this.showProductDetails = false;
    // this.prodUnavailable = false;

    this.subscription.push(this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.reInitialiseGrowerCmp();
        this.isReadOnly = false;
      }
    }));

    this.subscription.push(this.activatedRoute.paramMap.subscribe(params => {
      if (+(params.get('accountNo')) >= 0) {
        this.accountId = +(params.get('accountNo'));
      }
    }));

    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));

    this.subscription.push(this.broadcastService.on<any>(this.configService.ACCOUNT_CHANGE).subscribe((data) => {
      if (data.hasAccountSelected != undefined) {
        this.selectedBillingType = data.hasAccountSelected;
      }
    }));
    this.cutCancelCancellationMessage = MasterConstants.CUTCANCEL_CANCELLATION_MESSAGE;
  }

  // Observe Input element change
  ngOnChanges(changes: SimpleChanges) {
    this.productSearchFilter = this.searchTypeList[0].value;
    if (changes.isInvalidEmail == undefined) {
      this.hasChangeAdded = false;
    }
    this.checkedItems = [];
    const currentGrowerOrderObj = changes.GrowerOrderObj ? <GrowerOrderData>changes.GrowerOrderObj.currentValue : null;
    const currentGrowerOrderItemList = changes.GrowerOrderItemList ? <any[]>changes.GrowerOrderItemList.currentValue : null;
    let AccountNo = 0;
    if (changes.AccountId === undefined) {
      if (changes.GrowerOrderObj !== undefined && <number>changes.GrowerOrderObj.currentValue !== undefined && <number>changes.GrowerOrderObj.currentValue !== null) {
        AccountNo = <number>changes.GrowerOrderObj.currentValue.accountNo;
      }
    }
    else {
      AccountNo = changes.AccountId.currentValue;
    }
    this.SelGrowerObj = currentGrowerOrderObj;
    if (!currentGrowerOrderObj || !currentGrowerOrderObj.orderID) {
      this.growerOrderNumber = '';
    }

    if (AccountNo && AccountNo != 0) {
      this.AccountId = +AccountNo;
      //if ((this.sellerData == undefined || this.sellerData == null)) {
      //  this.GetSellerList();
      //}
    }
    let isSellerListBindThroughGrower = false;
    if (currentGrowerOrderObj && currentGrowerOrderObj.orderID) {
      this.SelGrowerObj = currentGrowerOrderObj;
      this.AccountId = +currentGrowerOrderObj.accountNo;
      //if ((this.sellerData == undefined || this.sellerData == null)) {
      //  this.GetSellerList();
      //}
      this.getAccountList(currentGrowerOrderObj.accountNo);
      this.getGrowerOrderDetails();
      this.checkHybridBtnAccess(+this.SelGrowerObj.accountNo);


      isSellerListBindThroughGrower = true;
    }
    //if (AccountNo == 0 && currentGrowerOrderItemList == null && currentGrowerOrderItemList == undefined) {
    //   this.AccountId = this.sliderModelService.toSellerAccountNo.value;
    //   this.GetSellerList();
    //}

    if (AccountNo && AccountNo != 0 && !isSellerListBindThroughGrower) {
      this.GetSellerList();
      this.checkHybridBtnAccess(AccountNo);
      if (changes.AccountId !== undefined) {
        this.growerOrderService.clearSelectedHybridProducts();
      }
    }

    if (currentGrowerOrderItemList && currentGrowerOrderItemList.length > 0) {
      currentGrowerOrderItemList.forEach(product => {
        product.ProductNameFilter = (product.brand != null ? product.brand : '');
        product.ChangeType = 'CHG';
      });
      this.bindDataSource(currentGrowerOrderItemList, true, true);
    }

    this.disablecheckbox = (this.filterGrowerOrderDSitems && this.filterGrowerOrderDSitems.length === 0);

    if (currentGrowerOrderObj && currentGrowerOrderObj.accountNo != '0') {
      this.disableOnLock = ((currentGrowerOrderObj.orderType != 'WB' || currentGrowerOrderObj.wfusB2BEnablement == 'Yes') && currentGrowerOrderObj.orderID !== '');
      this.enableAddProduct = false;

    }

    if (changes.GrowerOrderObj && !changes.GrowerOrderObj.firstChange) {
      this.loadGrowerLicenseActionMessage();
    }

    this.ValidateSaveButton();
  }

  reInitialiseGrowerCmp() {
    this.resetProductFilter();
    this.errorMsgs = new Array();
    this.GetErrorMsgs.emit(this.errorMsgs);
    if (this.isUpdateAction
      || this.hasChangeAdded) {
      this.hasChangeAdded = false;
      this.checkedItems = [];
      this.getGrowerOrderDetails();
    }
    this.isUpdateAction = false;
  }

  // Data call on InIT
  ngOnInit(): void {
    this.isInMobileApp = this.isInWebView();

    if (this.isMobile || this.isInMobileApp) {
      this.IsMobile = true;

      this.subscription.push(this.commonService.seedOrderGrowerGMK.subscribe(growerGMK => {
        if (growerGMK && growerGMK > 0) {
          this.growerGMK = growerGMK;
        }
      }));

      this.subscription.push(this.commonService.seedOrderDealerAccount.subscribe(ac => {
        if (ac && ac > 0) {
          this.selectedDealerAccount = ac;
        }
      }));

    }

    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.subscription.push(this.broadcastService.on<any>(this.configService.NAVIGATE_TO_BREADCRUMB).subscribe((data) => {
      if (data
        && data.naigateToBreadCrumb == true) {
        this.growerId = '0';
        this.getGrowerOrderDetails();
      }
    }));

    this.productSearchFilter = this.searchTypeList[0].value;
    this.bindDataSource([], true, true);

    this.subscription.push(this.sliderModelService.modelData.subscribe(x => {
      if (x != null && x.selectedProductList && x.selectedProductList.length > 0 && this.SelGrowerObj) {
        this.isAddProductClick = x.isAddProductClick;
        const isHybrid = x.source === 'GrowerOrderAddHybridProductComponent';
        this.convertDataToPass(x.selectedProductList, isHybrid);
      }

      if (x instanceof Array) {
        const orderList = [];
        this.isAddProductClick = true;
        this.growerOrderDS.data.forEach(obj => { if (!obj.isSelected) { orderList.push(obj); } });
        x.forEach(item => item.isSelected = true);
        orderList.push.apply(orderList, x);
        this.onClose(orderList);
        if (this.hasChangeAdded == true) {
          this.editToolKit = false;
          this.isReadOnly = true;
        }
      }
    }, (error => {
      LolLoggerService.error(error);
    })));
    this.errorMsgs = new Array();
    this.GetErrorMsgs.emit(this.errorMsgs);
    this.resetProductFilter();
    this.loadMasterData();
    this.ValidateSaveButton();

    // Get Active CropYear
    if (this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR)) {
      this.activeCropYear = JSON.parse(this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR));
    }

    this.accessTypeMode = false;
    setTimeout(x => {
      this.accessTypeMode = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.GROWER_ORDERS_TAB);
    }, 500);

    this.validateDateFilter();
    this.validateDeliveryDateFilter();

    if (this.growerOrderDS.data.length > 0) {
      this.growerOrderDS.data.forEach(x => {
        this.blockHideShow(x.rowId, false);
      });
    }

    this.hasGrowerLicensePageAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.LICENSE_EVOLVE);

  }

  private loadGrowerLicenseActionMessage(): void {
    const messageCode = (!this.hasGrowerLicensePageAccess || this.IsMobile)
      ? MasterConstants.MESSAGE_GROWER_LICENSE_MISSING_MOBILE
      : MasterConstants.MESSAGE_GROWER_LICENSE_MISSING;

    this.subscription.push(this.commonService.getMessageConfiguration(messageCode).subscribe((result: any) => {
      this.licenseActionMessageHtml = this.buildLicenseActionMessageHtml(result?.message, messageCode);
    }, error => {
      LolLoggerService.error(error);
      this.licenseActionMessageHtml = '';
    }));
  }

  private buildLicenseActionMessageHtml(message: string, messageCode: string): string {
    if (!message) {
      return '';
    }

    const growerLicenseDisplayUrl = this.getGrowerLicenseUrl();
    const growerLicenseRedirectUrl = this.getLicenseRedirectUrl();
    const agcelerateUrl = MasterConstants.AGCELERATE_REGISTRATION_URL;
    let resolvedMessage = message;

    if (messageCode === MasterConstants.MESSAGE_GROWER_LICENSE_MISSING_MOBILE) {
      resolvedMessage = resolvedMessage.replace(/\{0\}/g, agcelerateUrl);
    } else {
      resolvedMessage = resolvedMessage.replace(/\{0\}/g, growerLicenseDisplayUrl).replace(/\{1\}/g, agcelerateUrl);
    }

    resolvedMessage = resolvedMessage.replace(/^(\s*)(Action Required:)/i, '$1<strong class="license-action-heading">$2</strong>');

    return resolvedMessage.replace(/https?:\/\/\S+/gi, (url: string) => {
      let trailing = '';
      let cleanUrl = url;
      if (/[.,)]$/.test(url)) {
        trailing = url.slice(-1);
        cleanUrl = url.slice(0, -1);
      }

      if (/\/licenses/i.test(cleanUrl)) {
        return '<a href="javascript:void(0)" class="license-action-link license-nav-link">' + growerLicenseDisplayUrl + '</a>' + trailing;
      }

      return '<a href="' + cleanUrl + '" class="license-action-link external-nav-link">' + cleanUrl + '</a>' + trailing;
    });
  }

  public onLicenseActionLinkClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const anchor = target?.closest('a.license-action-link') as HTMLAnchorElement;
    if (!anchor) {
      return;
    }

    event.preventDefault();

    if (anchor.classList.contains('license-nav-link')) {
      this.navigateToLicensePage();
      //this.navigateWithLeaveConfirmation(() => this.navigateToLicensePage());
      return;
    }

    if (anchor.classList.contains('external-nav-link')) {
      const externalUrl = anchor.getAttribute('href') || '';
      if (!externalUrl) {
        return;
      }
      window.open(externalUrl, '_blank', 'noopener');
    }
  }

  private navigateWithLeaveConfirmation(navigateAction: () => void): void {
    if (!this.hasChangeAdded) {
      navigateAction();
      return;
    }

    const title = 'Leave without saving?';
    const message = 'Unsaved changes on this grower order will be lost. Do you want to continue?';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
    });

    this.subscription.push(dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
        navigateAction();
      }
    }));
  }

 
  private navigateToLicensePage(): void {
    const growerOrderNumber = (this.growerOrderNumber || '').toString().trim();
    const growerName = this.getGrowerNameForLicenseSearch((this.SelGrowerObj?.growerName || '').toString());

    if (growerOrderNumber) {
      this.router.navigate(['/licenses', 'Unlicensed', growerOrderNumber]);
      return;
    }

    if (growerName) {
      this.router.navigate(['/licenses', 'grower', growerName]);
      return;
    }

    this.router.navigate(['/licenses', 'Unlicensed']);
  }

  private getLicenseRedirectUrl(): string {
    const growerOrderNumber = (this.growerOrderNumber || '').toString().trim();
    const growerName = this.getGrowerNameForLicenseSearch((this.SelGrowerObj?.growerName || '').toString());
    const licenseStatus = 'Unlicensed';

    if (growerOrderNumber) {
      return window.location.origin + '/licenses/' + licenseStatus + '/' + encodeURIComponent(growerOrderNumber);
    }

    return growerName
      ? window.location.origin + '/licenses/grower/' + growerName
      : window.location.origin + '/licenses/' + licenseStatus;
  }

  private getGrowerNameForLicenseSearch(growerName: string): string {
    if (!growerName) {
      return '';
    }

    return growerName
      .replace(/\s*-\s*[^,]+$/, '')
      .replace(/,\s+/g, ',')
      .trim();
  }

  private getGrowerLicenseUrl(): string {
    return window.location.origin + '/licenses';
  }

  public resetProductFilter() {
    this.filterValueList = [];
    this.productFilters = {
      'IsAvailabilityChecked': false,
      'ProductNameFilter': null,
      'MarketingBrandList': [],
      'SeedSizeList': [],
      'PackageSizeList': [],
      'TechnologyList': null,
      'TreatmentList': [],
      'ProductLineList': [],
      'MaturityMin': null,
      'MaturityMax': null,
    };
  }

  public selectProductName($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.ProductNameFilter = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.ProductNameFilter = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.ProductNameFilter = this.partialSearchValue;
        }
      }
    }
    else {
      this.resetProductFilter();
    }

    this.keepFilter();
  }

  public selectTechnology($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.TechnologyList = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.TechnologyList = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.TechnologyList = this.partialSearchValue;
        }
      }
    }
    else {
      this.resetProductFilter();
    }

    this.keepFilter();
  }

  public keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.ProductNameFilter && this.productFilters.ProductNameFilter != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.ProductNameFilter);
        }
        if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) {
          let strMB = '';
          this.productFilters.MarketingBrandList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
        }
        if (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) {
          let strSS = '';
          this.productFilters.SeedSizeList.forEach(x => {
            strSS = strSS + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strSS.substr(0, strSS.length - 2));
        }
        if (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) {
          let strPS = '';
          this.productFilters.PackageSizeList.forEach(x => {
            strPS = strPS + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strPS.substr(0, strPS.length - 2));
        }
        if (this.productFilters.TechnologyList && this.productFilters.TechnologyList.length != '') {
          this.filterValueList.push('Technology : ' + this.productFilters.TechnologyList);
        }
        if (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) {
          let strTreat = '';
          this.productFilters.TreatmentList.forEach(x => {
            strTreat = strTreat + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strTreat.substr(0, strTreat.length - 2));
        }
        if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) {
          let strPL = '';
          this.productFilters.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));
        }
        let maturityMin = '';
        let maturityMax = '';
        if (this.productFilters.MaturityMin != null && this.productFilters.MaturityMax != null) {
          maturityMin = this.productFilters.MaturityMin;
          maturityMax = this.productFilters.MaturityMax;
          this.filterValueList.push('Maturity : (' + maturityMin + ') - (' + maturityMax + ')');
        }
      }
    }
    this.applyFilterData(this.productFilters);
    this.searchValue = '';
    this.partialSearchValue = '';
  }

  // Load Master Data
  public loadMasterData() {
    // MarketingBrand master data
    if (this.headerCompany == MasterConstants.US_COMPANYCODE) {
      if (this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST)) {
        this.marketingMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST));
      }
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.seedsizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST)) {
      this.packagesizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST));
    }

    // Technology master data
    if (this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST)) {
      this.technologyMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    // Maturity master data
    if (this.localStorageService.get(MasterConstants.MATURITY_LIST)) {
      this.maturityMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MATURITY_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }
  }

  public filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.value.toLocaleLowerCase().indexOf(term) > -1;
  }

  public partialSearch(searchValue: string) {
    if (searchValue != undefined) {
      this.partialSearchValue = searchValue;
    }
  }

  public clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    this.productList = new Array();
    this.resetProductFilter();
    this.applyFilterData(this.productFilters);
  }

  public clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);
      this.applyFilterData(this.productFilters);
      if (this.filterValueList.length < 1) {
        // remove all filter
      }
    }
  }

  // To remove clear search filter
  public removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Product Name':
        // this.productFilters.ProductNameFilter = null;
        this.productFilters.ProductNameFilter = '';
        break;
      case 'Manufacturer':
      case 'Marketing Brand':
        this.productFilters.MarketingBrandList = [];
        break;
      case 'Seed Size':
        this.productFilters.SeedSizeList = [];
        break;
      case 'Package Size':
        this.productFilters.PackageSizeList = [];
        break;
      case 'Technology':
        this.productFilters.TechnologyList = '';
        break;
      case 'Treatment':
        this.productFilters.TreatmentList = [];
        break;
      case 'Maturity':
        this.productFilters.MaturityMin = null;
        this.productFilters.MaturityMax = null;
        break;
      case 'Product Line':
        this.productFilters.ProductLineList = [];
        break;
      default:
        break;
    }
  }

  // Set No of products and
  setCount() {
    this.filteredDataCount = 0;
    this.bagCount = 0;
    this.filteredDataCount = this.growerOrderDS.data.length;
    this.growerOrderDS.data.forEach(x => { this.bagCount = this.bagCount + +(x.geu); });
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  // Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Design : Set height
  setHeight() {
    const templateHeight = window.innerHeight - $('.search-section').outerHeight() - 76;
    $('.order-view-sec').css('max-height', templateHeight + 'px');

    const GrowerAddSecHeight = window.innerHeight - $('.search-section').outerHeight() - 96;
    $('.order-view-sec .grower-add-sec').css('min-height', GrowerAddSecHeight + 'px');
  }

  // Date validation
  validateDate(productItem: any) {
    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.growerOrderListCopy)).filter(x => x.rowId == productItem.rowId)[0];
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldDateValue: oldProductLineValue.desiredDeliveryDate, newDateValue: productItem.desiredDeliveryDate });
    if (productItem.lineErrors && productItem.lineErrors.errors && productItem.lineErrors.errors.length > 0) {
      this.validateLineItem(productItem, '');
      this.setCount();
    }

    this.updateUnlicensedState(this.growerOrderDS.data);
  }

  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);

      const calendarDate = d;// .getDate();
      let maxDate = new Date();
      if (this.activeCropYear) {
        maxDate = new Date(this.activeCropYear.endDate);
      }
      // Prevent Saturday and Sunday from being selected.
      return calendarDate >= currentDate && calendarDate <= maxDate;
    };
  }

  validateDeliveryDateFilter() {
    const currentDate = new Date();
    let maxDate = new Date();
    if (this.activeCropYear) {
      maxDate = new Date(this.activeCropYear.endDate);
    }
    this.config.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
    this.datemodel = this.configDate.getToday();
    this.config.maxDate = { year: maxDate.getFullYear(), month: maxDate.getMonth() + 1, day: maxDate.getDate() };
  }

  // Enable Tool Kit
  EnableAllEditToolKit(isChecked: boolean) {
    this.isSearchClicked = false;
    this.editToolKit = isChecked;
    if (this.growerOrderDS) {
      if (isChecked) {
        this.selectedCount = 0;
        this.filterGrowerOrderDSitems.forEach(item => {
          if (item.isProductDeactivated == false
            || (item.deactivationType != null && item.deactivationType.trim().toLowerCase() != 'suspend')) {
            this.selectedCount = this.selectedCount + 1;
            item.isSelected = true;
          }
        });
      }
      else {
        this.filterGrowerOrderDSitems.forEach(item => {
          item.isSelected = false;
          item = this.validateLineItem(item, 'deactivationType');
          this.selectedCount = 0;
        });
        this.tabNode = '';
      }
    }
  }

  // Enable tool kit on single
  activeEditToolKit(isChecked: boolean) {
    this.isSearchClicked = false;
    if (this.growerOrderDS) {
      this.selectedCount = 0;
      this.filterGrowerOrderDSitems.forEach(item => {
        if (item.isSelected) {
          this.selectedCount = this.selectedCount + 1;
        } else {
          item = this.validateLineItem(item, 'deactivationType');
        }
      });

      if (this.selectedCount === this.filterGrowerOrderDSitems.length && this.filterGrowerOrderDSitems.length > 0) {
        this.EnableAllEditToolKit(true);
      }
    }
    else {
      if (isChecked) {
        this.selectedCount = this.selectedCount + 1;
      }
      else {
        this.selectedCount = this.selectedCount - 1;
      }
    }
    this.editToolKit = (this.selectedCount > 0);
  }

  // Qty change on +/- sign click
  geuValueChange(action: string, productItem: any) {
    if (action == 'decrease') {
      if (this.decreasedItemList.find(x => x.itemID == productItem.itemID) == undefined) {
        this.decreasedItemList.push(productItem.itemID);
      }

      this.growerOrderDS.data.forEach(x => {
        if (x.rowId == productItem.rowId) {
          const decValue = +productItem.geu - +productItem.conv;
          if (decValue > 0) {
            const valueBeforeDec = productItem.geu;
            productItem.geu = Math.floor(productItem.geu / +productItem.conv) * +productItem.conv;
            if (valueBeforeDec == productItem.geu) {
              productItem.geu = (+productItem.geu > +productItem.conv ? +productItem.geu - +productItem.conv : 0);
            }
            if (productItem.cutCancelOverWarning) {
              if (this.growerOrderDataCopy) {
                this.growerOrderDataCopy.forEach(y => {
                  if (y.rowId == productItem.rowId) {
                    if (productItem.geu < y.geu) {
                      productItem.showCutCancelOverWarning = productItem.cutCancelOverWarning;
                    }
                  }
                });
              }
            }
          }
          else {
            productItem.geu = 0;
          }
        }
      });
    }
    else {
      this.growerOrderDS.data.forEach(x => {
        if (x.rowId == productItem.rowId) {
          const valueBeforeInc = productItem.geu;
          productItem.geu = Math.ceil(productItem.geu / +productItem.conv) * +productItem.conv;
          if (valueBeforeInc == productItem.geu) {
            productItem.geu = (+productItem.geu + +productItem.conv);
            if (this.growerOrderDataCopy) {
              this.growerOrderDataCopy.forEach(y => {
                if (y.rowId == productItem.rowId) {
                  if (productItem.geu >= y.geu) {
                    productItem.showCutCancelOverWarning = false;
                  }
                }
              });
            }
          }
        }
      });
    }
    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.growerOrderListCopy)).filter(x => x.rowId == productItem.rowId)[0];
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldGeuValue: oldProductLineValue.geu, newGeuValue: productItem.geu });

    this.setCount();
    if (productItem.isSelected != true) {
      productItem.isSelected = true;
      this.activeEditToolKit(true);
    }
    if (productItem.lineErrors && productItem.lineErrors.errors && productItem.lineErrors.errors.length > 0) {
      this.validateLineItem(productItem, '');
      this.setCount();
    }

    this.updateUnlicensedState(this.growerOrderDS.data);
  }

  // Qty change on text change
  geuTextChange(productItem: any) {
    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.growerOrderListCopy)).filter(x => x.rowId == productItem.rowId)[0];
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldGeuValue: oldProductLineValue.geu, newGeuValue: productItem.geu });

    const index: number = this.decreasedItemList.indexOf(productItem.itemID);
    if (index !== -1) {
      this.decreasedItemList.splice(index, 1);
    }

    if (oldProductLineValue.geu > productItem.geu) {
      if (this.decreasedItemList.find(x => x.itemID == productItem.itemID) == undefined) {
        this.decreasedItemList.push(productItem.itemID);
      }
    }
    if (productItem.lineErrors && productItem.lineErrors.errors && productItem.lineErrors.errors.length > 0) {
      this.validateLineItem(productItem, '');
      this.setCount();
    }
  }

  // get call on customer po change
  GridCustomerPoChange(customerValue: any, obj: any) {
    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.growerOrderListCopy)).filter(x => x.rowId == obj.rowId)[0];
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldCustomerPoValue: oldProductLineValue.customerPO, newCustomerPoValue: customerValue });
  }

  // Get all grower order Data
  getGrowerOrderDetails() {
    this.AccountId = +this.SelGrowerObj.accountNo;
    this.GetSellerList();
    this.bindDataSource([], true, true);
    this.activeEditToolKit(false);
    this.EnableAllEditToolKit(false);
    if (this.SelGrowerObj) {
      this.loaderService.setLoaderStatus(true);

      this.subscription.push(this.growerOrderService.getGrowerOrderItems(
        this.SelGrowerObj.growerOrderId.toString(),
        this.SelGrowerObj.accountNo.toString(),
        this.headerYear,
      ).subscribe((results: any[]) => {
        this.loaderService.setLoaderStatus(true);
        if (results.length > 0 && results[0].growerOrderItemId != 0 && this.growerId != '0') {
          results.forEach(x => {
            x.sellerID = (x.sellerID == 0 ? null : x.sellerID);
            x.ChangeType = 'CHG';
            x.initialGEU = x.geu;
          });
          this.growerOrderNumber = results[0].growerOrderNumber;
          this.bindDataSource(results, true, true);
          this.syncSelectedHybridProductsWithOrder(results);
          this.loadGrowerLicenseActionMessage();
        }
        else {
          this.growerOrderNumber = '';
          this.bindDataSource([], true, true);
          this.growerOrderService.clearSelectedHybridProducts();
          this.loadGrowerLicenseActionMessage();
        }
        this.loaderService.setLoaderStatus(false);
      }, (error => {
        LolLoggerService.error(error);
        this.loaderService.setLoaderStatus(false);
      })));
      if (this.growerOrderDS.data[0]) {
        this.dealerOrderNumber = this.growerOrderDS.data[0].dealerOrderNumber;
      }
      else {
        this.dealerOrderNumber = '';
      }
    }
    if (this.growerId === '0') { this.SelGrowerObj = null; }
  }

  syncSelectedHybridProductsWithOrder(orderItems: any[]) {
    const hybridItems = (orderItems || []).filter(item => item && item.IsHybridVarietyPackageSize && item.geu > 0);
    this.growerOrderService.syncSelectedHybridProductsForOrder(hybridItems);
  }

  bindCustomFieldValues(resObj: any) {
    let rowId: Number = 0;
    resObj.forEach(product => {
      product.productNameFilter = (product.brand != null ? product.brand : '');
      rowId = +rowId + 1;
      // need to remove :
      product.rowId = +rowId;
      product.lineErrors = { 'rowId': product.rowId, 'errors': [] };
    });
    return resObj;
  }

  // Set Tab to show
  showTab(tabid: string) {
    this.tabNode = tabid;
    if (tabid === 'delete') {
      this.filterGrowerOrderDSitems.forEach(item => {
        if (item.isSelected) {
          if (item.cutCancelOverWarning) {
            item.showCutCancelOverWarning = true;
          }
        }
      });
    }
  }

  showDetails(event: UIEvent, element, column): void {
    element.selected = column.toString();
  }

  showProdDetails(event: UIEvent, element, column): void {
    element.selected = column.toString();
    if (element.isSelected == true && element.selected === 'product') {
      element.showProductDetails = true;
    } else if (element.selected === 'product') {
      element.showProductDetails = true;
    }
  }

  hideProdDetails(event: UIEvent, element, column): void {
    element.selected = column.toString();

    element.showProductDetails = false;
  }

  // Filter grid data on type
  applyFilterData(filterValue: any) {
    this.filterGrowerOrderDSitems = [];
    this.filteredDataCount = 0;
    this.bagCount = 0;
    this.growerOrderDS.filter = filterValue;
    this.selectedCount = 0;
    this.filterGrowerOrderDSitems.forEach(item => {
      if (item.isSelected) {
        this.selectedCount = this.selectedCount + 1;
      }
    });
  }

  // Get All Account List
  getAccountList(accountNumber: string) {
    this.subscription.push(this.growerOrderService.getAccounts().subscribe((results: any[]) => {
      const accountObj = results.find(x => x.accountNumber == accountNumber);
      if (accountObj) {
        this.SelAccountObj = accountObj;
        if (this.SelAccountObj
          && this.SelAccountObj.billingAddressType) {
          this.selectedBillingType = this.SelAccountObj.billingAddressType;
        }
      }
    }, error => { LolLoggerService.error(error); }));
  }



  // check Hybrid Btn Access
  checkHybridBtnAccess(accountNumber: any) {
    if (!this.executeAccessApi || this.checkedAccountForAccess != accountNumber) {
      this.subscription.push(this.growerOrderService.hasAddHybridBtnAccess(accountNumber).subscribe((result: any) => {
        this.disabledHybridVariety = !result.isEligible;
        this.hybridErrorToolTip = !result.isEligible ? "This option is not available: " + result.blockingReason : "";
        this.executeAccessApi = true;
        this.checkedAccountForAccess = accountNumber;
        this.hybridVarietyProductLines = result.productLineList;
        this.hybridVarietyMarketingBrands = result.marketingBrandList;

      }, error => { LolLoggerService.error(error); }));
    }
  }



  // Edit Region : Start

  // convert data in DataSource Type
  convertDataToPass(productList: any[], isHybrid: boolean = false) {
    const orderList = [];
    productList.forEach(x => {
      orderList.push({
        isSelected: true,
        growerOrderID: this.SelGrowerObj.growerOrderId,
        growerGMK: this.SelGrowerObj.gmk,
        shipToAccount: this.SelGrowerObj.accountNo,
        desiredDeliveryDate: x.desiredDeliveryDate || '',
        createTimeStamp: new Date(),
        updateTimeStamp: new Date(),
        itemID: x.itemId,
        brand: x.brand,
        itemNumber: x.itemNumber,
        dealerOrderNumber: '',
        growerOrderNumber: this.growerOrderNumber,
        growerOrderItemId: 0,
        lineNumber: '',
        itemDescription: x.itemDescription,
        seedSize: x.seedSize,
        treatment: x.treatment,
        maturity: x.maturity,
        technology: x.technology,
        productLine: x.productLine,
        marketingBrand: x.marketingBrand,
        packageSize: x.packageSize,
        customerPO: '',
        status: 'Y',
        conv: x.conv,
        seedAvailability: x.seedAvailability,
        geu: x.assignedQuantity || x.reservationUnits || 0,
        IsHybridVarietyPackageSize: isHybrid,
        IsReservationConversion: false,
        netGEU: x.netGEU,
        netBEU: x.netBEU,
        sellerID: new Number(),
        longShortPosition: x.longShortPosition,
        highlightPackage: x.highlightPackage,
        highlightTreatment: x.highlightTreatment,
        highlightTechnology: x.highlightTechnology,
        myDealerBucketQty: x.myDealerBucketQty,
        myDealerBucket: x.myDealerBucket,
        softCommitUnits: x.softCommitUnits,
        plannedUnits: x.plannedUnits,
        shippedUnits: x.shippedUnits,
        primaryUOM: x.primaryUOM,
        secondaryUOM: x.secondaryUOM,
        dealerModifiableUnits: x.dealerModifiableUnits,
        isProductDeactivated: x.isProductDeactivated,
        deactivationType: x.deactivationType,
        ChangeType: 'ADD',
        stockTransferUnits: x.stockTransferUnits,
        seedNonReturnable: x.seedNonReturnable,
        isUnlicensed: x.isUnlicensed === true,
      });
    });

    this.growerOrderDS.data.forEach(x => {
      orderList.push(x);
    });
    this.onClose(orderList);
  }

  // Process on Slider Close
  onClose(selectedProductList: any[]): void {
    this.errorMsgs = new Array();
    this.GetErrorMsgs.emit(this.errorMsgs);
    // if (selectedProductList.length > 0) {
    //  var rowId: Number = 0;
    //  selectedProductList.forEach(x => {
    //    rowId = +rowId + 1;
    //    x.rowId = +rowId;
    //    x.lineErrors = { "rowId": x.rowId, "errors": [] };
    //    //x.isSelected = true;
    //  });
    // }

    if (this.isAddProductClick == true && selectedProductList.length > 0) {
      selectedProductList.forEach(product => {
        product.productNameFilter = (product.brand != null ? product.brand : '');
        //  product.ChangeType = 'ADD';
      });

      this.bindDataSource(selectedProductList, true, false);
      this.activeEditToolKit(true);
    }
    this.sliderModelService.close();
  }

  // Open Slider model
  openSliderModel() {
    if (this.selectedBillingType && this.selectedBillingType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
      this.sliderModelService.initializeProductChangeVal({
        companyCode: this.headerCompany,
        cropYear: this.headerYear,
        accountNo: +this.SelGrowerObj.accountNo,
        action: '',
        data: [],
        dealerData: [],
        page: 'growerOrder',
        isAccountRIB: false
      });

      this.sliderModelService.initializeComponentVal(this.AccountId);
      this.sliderModelService.activeSlider('AddProductSlider');
      this.sliderModelService.selectedPerson('Grower');
    }
    else {
      this.toastrService.warning('Account not eligible for Ordering.');
    }
  }
  OpenAddHybridProductSlider() {

    //this.sliderModelService.activeSlider('growerOrderHybridAddProductSlider');

    if (this.selectedBillingType && this.selectedBillingType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
      // Marketing Brand and Product Line are derived from the selected grid products
      const selectedItems = this.filterGrowerOrderDSitems.filter(x => x.isSelected);

      const selectedProduct = selectedItems[0];
      // let sellerName = '';
      // let sellerAccountNo = 0;
      // if (selectedProduct.sellerID && this.sellerData) {
      //   const seller = this.sellerData.find(s => s.accountNumber == selectedProduct.sellerID);
      //   if (seller) {
      //     sellerName = seller.accountName;
      //     sellerAccountNo = +seller.accountNumber;
      //   }
      // }

      this.sliderModelService.setGrowerOrderHybridAddProductChangeVal({
        companyCode: this.headerCompany,
        cropYear: +this.headerYear,
        accountNo: +this.SelGrowerObj.accountNo,
        marketingBrand: this.hybridVarietyMarketingBrands,
        productLine: this.hybridVarietyProductLines,
        page: 'growerOrder',
        isAccountRIB: this.SelGrowerObj.isAccountRIB,
        data: selectedItems,
        shipToName: this.SelGrowerObj.growerName || '',
        shipToAccountAddress1: this.SelGrowerObj.growerAddress || '',
        shipToCity: this.SelGrowerObj.city || '',
        shipToState: this.SelGrowerObj.state || '',
        shipToZipCode: this.SelGrowerObj.zip || '',
        shipToContact: '',
        sellerName: '',
        sellerAccountNo: 0,
        growerOrderNumber: this.SelGrowerObj.orderID || '',
        growerOrderId: this.SelGrowerObj.growerOrderId || 0,
        gmk: this.SelGrowerObj.gmk,
        marketingBrandId: null,
        productLineId: null,
        isParentGMK: false,
        reservationUnits: 0
      });
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
      this.sliderModelService.activeSlider('growerOrderHybridAddProductSlider');
    }
    else {
      this.toastrService.warning('Account not eligible for Ordering.');
    }
  }
  // Open Different dealer Grower Order Transfer Slider model
  openDiffDealerGrowerTransferSliderModel() {
    // this.sliderModelService.initializeComponentVal(this.AccountId);
    // this.sliderModelService.activeSlider('DiffDealerGrowerOrderTransferSlider');
    if (this.growerOrderDS.data && this.growerOrderDS.data.length > 0) {
      let errorFlag = false;
      // TODO: Commented error handling to validate later
      this.growerOrderDS.data.forEach(x => {
        if (x.isSelected) {
          x = this.validateLineItem(x, 'deactivationType');
          if (!(x.lineErrors.errors.length === 0)) {
            errorFlag = true;
          }
        }
      });
      if (!errorFlag) {
        this.selectedGrowerToGrowerItemList = [];
        this.sliderModelService.growerSearchType.next('OTHER_DEALER_TFR');
        this.sliderModelService.initializeComponentVal(this.AccountId);
        this.SetAllFields('G2G', this.sellerId);
        this.sliderModelService.setg2gTranferUnit<any>(this.selectedGrowerToGrowerItemList);
        this.sliderModelService.activeSlider('DiffDealerGrowerOrderTransferSlider');
      }
    }
  }

  // Open Order Transfer Slider model
  openOrderTransferSliderModel() {
    if (this.selectedBillingType && this.selectedBillingType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
      const dataItems = this.filterGrowerOrderDSitems.filter(x => x.isSelected && (x.growerOrderNumber == '' || x.lineNumber == ''));

      if (this.buttonType == 'add') {
        if (dataItems && dataItems.length > 0) {
          return false;
        }
      }

      if (this.hasChangeAdded) {
        const title = 'Leave without saving?';
        const message = '';
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
        });

        this.subscription.push(dialogRef.afterClosed().subscribe(result => {
          // If user selected Yes
          if (result == true) {
            this.revertToPreviousState(false);
            this.selectedGrowerToGrowerItemList = [];
            this.sliderModelService.growerSearchType.next('SAME_DEALER_TFR');
            this.sliderModelService.initializeComponentVal(this.AccountId);
            this.SetAllFields('G2G', this.sellerId);
            this.sliderModelService.setg2gTranferUnit<any>(this.selectedGrowerToGrowerItemList);
            this.sliderModelService.activeSlider('orderTransferSlider');
          }
        }));
      }
      else {
        this.selectedGrowerToGrowerItemList = [];
        this.sliderModelService.growerSearchType.next('SAME_DEALER_TFR');
        this.sliderModelService.initializeComponentVal(this.AccountId);
        this.SetAllFields('G2G', this.sellerId);
        this.sliderModelService.setg2gTranferUnit<any>(this.selectedGrowerToGrowerItemList);
        this.sliderModelService.activeSlider('orderTransferSlider');
      }
    }
    else {
      this.toastrService.warning('Account not eligible for Ordering.');
    }
  }

  // Open change Product Slider model
  openChangeProductSliderModel(action: string) {
    if (this.selectedBillingType && this.selectedBillingType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
      let dataItems = this.filterGrowerOrderDSitems.filter(x => x.isSelected && (x.growerOrderNumber == '' || x.lineNumber == ''));
      if (this.buttonType == 'add') {
        if (dataItems && dataItems.length > 0) {
          return false;
        }
      }

      if (this.hasChangeAdded) {
        const title = 'Leave without saving?';
        const message = '';
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
        });

        this.subscription.push(dialogRef.afterClosed().subscribe(result => {
          // If user selected Yes
          if (result == true) {
            this.revertToPreviousState(false);
            dataItems = this.filterGrowerOrderDSitems.filter(x => x.isSelected && x.growerOrderNumber != '' && x.geu != 0 && x.growerOrderItemId > 0);
            this.sliderModelService.initializeProductChangeVal({
              companyCode: this.headerCompany,
              cropYear: this.headerYear,
              accountNo: +this.SelGrowerObj.accountNo,
              action: action,
              data: dataItems as GrowerOrderItemVM[],
              dealerData: [],
              page: 'growerOrder',
              isAccountRIB: this.SelGrowerObj.isAccountRIB
            });
            this.sliderModelService.activeSlider('ChangeProductSlider');
          }
        }, (error => {
          LolLoggerService.error(error);
        })));
      }
      else {
        dataItems = this.filterGrowerOrderDSitems.filter(x => x.isSelected && x.growerOrderNumber != '' && x.geu != 0 && x.growerOrderItemId > 0);
        this.sliderModelService.initializeProductChangeVal({
          companyCode: this.headerCompany,
          cropYear: this.headerYear,
          accountNo: +this.SelGrowerObj.accountNo,
          action: action,
          data: dataItems as GrowerOrderItemVM[],
          dealerData: [],
          page: 'growerOrder',
          isAccountRIB: this.SelGrowerObj.isAccountRIB
        });
        this.sliderModelService.activeSlider('ChangeProductSlider');
      }
    }
    else {
      this.toastrService.warning('Account not eligible for Ordering.');
    }
  }

  revertToPreviousState(isCheckBoxRevert: boolean) {
    if (isCheckBoxRevert) {
      this.growerOrderDataCopy.forEach(item => {
        item.isSelected = false;
      });
      this.localStorageService.set('Modify', '[]');
    }
    else {
      const checkedIds = [];
      const growerDsItems = JSON.parse(JSON.stringify(this.growerOrderDS.data));

      for (let i = 0; i < growerDsItems.length; i++) {
        if (growerDsItems[i].isSelected == true
          && growerDsItems[i].growerOrderItemId > 0) {
          checkedIds.push(growerDsItems[i].growerOrderItemId);
        }
      }

      this.growerOrderDataCopy.forEach(item => {
        if (checkedIds.length > 0
          && item.growerOrderItemId > 0
          && checkedIds.includes(item.growerOrderItemId)) {
          item.isSelected = true;
        }
        else {
          item.isSelected = false;
        }
      });
    }

    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
    this.growerOrderDS.data = JSON.parse(JSON.stringify(this.growerOrderDataCopy));
    this.checkedItems = [];
    this.isReadOnly = false;
    this.growerOrderService.clearSelectedHybridProducts();

    // reset common error msgs
    this.errorMsgs = new Array();
    this.GetErrorMsgs.emit(this.errorMsgs);

    this.bindDataSource(this.growerOrderDS.data.filter(x => x.growerOrderItemId > 0), true, true);
    this.clearAllFilter();
  }

  // Get All seller list
  GetSellerList() {
    if (this.AccountId != 0) {
      this.subscription.push(this.growerOrderService.getSellerList(this.AccountId.toString()).subscribe(result => {
        this.sellerData = result?.sort((a, b) => (a?.accountName ?? '').localeCompare(b?.accountName ?? ''));
      }, error => { LolLoggerService.error(error); }));
    }
  }

  // get call on seller change
  SellerChange($event) {
    if ($event != null && $event.accountNumber != null) {
      this.sellerId = $event.accountNumber;
      this.SetAllFields('sellerid', this.sellerId);
      this.sellerId = null;
    }
  }

  // get call on seller change
  GridSellerChange($event: any, obj: any) {
    if ($event != null && $event.accountNumber != null && $event != undefined) {
      this.growerOrderDS.data.forEach(item => {
        if (item.rowId == obj.rowId) {
          item.sellerID = $event.accountNumber;
        }
      });
      // get old data
      const oldProductLineValue = JSON.parse(JSON.stringify(this.growerOrderListCopy)).filter(x => x.rowId == obj.rowId)[0];
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldSellerValue: oldProductLineValue.sellerID, newSellerValue: $event.accountNumber });
    }
  }

  SellerAccountChange($event) {
    this.sellerId = null;
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
  }

  // Clear model on seller removal
  SellerAccountClear($event) {
    this.sellerId = '';
  }

  // update grid value from toolKit on update
  SetAllFields(field: string, value: any) {
    switch (field) {
      case 'deliverydate':
        this.filterGrowerOrderDSitems.forEach(item => {
          if (item.isSelected) {
            item.desiredDeliveryDate = new Date(value.year, value.month - 1, value.day);
            this.validateDate(item);
          }
        });
        this.validateDeliveryDateFilter();
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
        break;
      case 'customerpo':
        this.filterGrowerOrderDSitems.forEach(item => {
          if (item.isSelected) {
            item.customerPO = value;
          }
        });
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
        this.customerPONo = '';
        break;
      case 'sellerid':
        this.filterGrowerOrderDSitems.forEach(item => {
          if (item.isSelected) {
            item.sellerID = value;
          }
        });
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
        break;
      case 'delete':
        const deletedHybridItems = [];
        this.filterGrowerOrderDSitems.forEach(item => {
          if (item.isSelected && value == true) {
            if (item.IsHybridVarietyPackageSize) {
              deletedHybridItems.push(item);
            }
            item.geu = 0;
            item.isSelected = false;
            this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
            if (item.growerOrderItemId == 0) {
              item.rowId = 0;
            }
            if (item.rowId > 0) { this.checkedItems[item.growerOrderItemId] = item.growerOrderItemId; }
          }
        });
        if (deletedHybridItems.length > 0) {
          this.growerOrderService.removeSelectedHybridProducts(deletedHybridItems);
        }
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
        this.activeEditToolKit(false);
        break;
      case 'G2G':
        this.filterGrowerOrderDSitems.forEach(item => {
          if (item.isSelected) {
            this.selectedGrowerToGrowerItemList.push(item);
          }
        });
        break;
      default:
        break;
    }

    this.growerOrderDS.data.forEach(product => {
      product.ProductNameFilter = (product.brand != null ? product.brand : '');
      // procuct.TechnologyList = product.
      // + (product.marketingBrand != null ? (" - " + product.marketingBrand) : "")
      // + (product.itemDescription != null ? (" " + product.itemDescription) : "");
    });

    if (this.errorMsgs.length > 0) {
      this.bindDataSource(this.growerOrderDS.data.filter(x => x.rowId != 0), false, false);
    } else {
      this.bindDataSource(this.growerOrderDS.data.filter(x => x.rowId != 0), true, false);
    }

    this.errorMsgs = new Array();
    this.growerOrderDS.data.forEach(item => {
      if (item.rowId > 0
        && item.lineErrors.errors.length > 0) {
        this.errorMsgs.push(item.lineErrors);
      }
    });
    this.GetErrorMsgs.emit(this.errorMsgs);

    // this.applyFilterData(this.productFilters);
    // this.EnableAllEditToolKit(false);
    this.tabNode = '';
  }

  // Enable and disable Edit Toolkit
  enableEditToolKit($event) {
    this.editToolKit = !this.editToolKit;
  }

  checkDealerInventory() {
    const groupList = [];
    let group = 0;
    this.availabilityLostList = [];
    // var filteredData = this.growerOrderDS.data.filter(x => x.deactivationType ? (x.deactivationType.trim().toLowerCase() !== 'suspend') : true);
    const filteredData = this.growerOrderDS.data.filter(x => x.isSelected == true);
    filteredData.forEach(item => {
      if (item.growerOrderItemId == 0) {
        groupList.push({
          group: group,
          toItemId: item.itemID,
          toItemNumber: item.itemNumber,
          toItemQuantity: item.geu,
          toItemAvailability: item.seedAvailability,
          itemId: 0,
          fromItemNumber: '',
          fromItemDescription: '',
          fromItemQuantity: 0,
          fromItemAvailability: 0,
          fromLongShortPosition: 0,
          fromNetGEU: 0,
          availableFromBefore: 0,
          availableFromAfter: 0,
          availableToAfter: Math.min(item.seedAvailability, item.geu)
        });
      }
      else {
        const groupData = groupList.filter(x => x.group == group);
        const quantityReduced = item.initialGEU - item.geu;
        const updatedFromValue = item.initialGEU - (item.initialGEU - item.geu);
        groupData.forEach(x => {
          x.itemId = item.itemID,
            x.fromItemNumber = item.itemNumber,
            x.fromItemDescription = item.itemDescription,
            x.fromItemQuantity = item.geu,
            x.fromItemAvailability = item.seedAvailability,
            x.fromLongShortPosition = item.longShortPosition,
            x.fromNetGEU = item.netGEU,
            x.availableFromBefore = item.longShortPosition >= 0 ? item.initialGEU : Math.max(0, item.initialGEU + (item.longShortPosition)),
            x.availableFromAfter = (item.longShortPosition + quantityReduced) >= 0 ? updatedFromValue : Math.max(0, updatedFromValue + (item.longShortPosition + quantityReduced)); // =IF($E8>=0,$D8,MAX(0,$D8+$E8))
        });
        group += 1;
      }
    });

    groupList.forEach(x => {
      if (x.availableFromBefore - (x.availableFromAfter + x.availableToAfter) > 0) {
        this.availabilityLostList.push({
          itemNumber: x.fromItemNumber,
          itemDescription: x.fromItemDescription
        });
      }
    });

    const list = filteredData.filter(x => {
      if (x.growerOrderItemId != 0 && this.decreasedItemList.indexOf(x.itemID) !== -1) {
        return x;
      }
    });
    list.forEach(item => {
      const oldProductLineValue = JSON.parse(JSON.stringify(this.growerOrderListCopy)).filter(x => x.rowId == item.rowId)[0];

      const quantityReduced = item.initialGEU - item.geu;
      const updatedFromValue = item.initialGEU - (item.initialGEU - item.geu);
      const availableBefore = oldProductLineValue.longShortPosition >= 0 ? oldProductLineValue.initialGEU : Math.max(0, oldProductLineValue.initialGEU + (oldProductLineValue.longShortPosition));
      const availableAfter = (item.longShortPosition + quantityReduced) >= 0 ? updatedFromValue : Math.max(0, updatedFromValue + (item.longShortPosition + quantityReduced));

      if ((availableBefore - availableAfter) > 0) {
        this.availabilityLostList.push({
          itemNumber: item.itemNumber,
          itemDescription: item.itemDescription
        });
      }
    });

    // distinct from item which qualified for warning
    this.availabilityLostList = this.availabilityLostList.filter((thing, index) => {
      const _thing = JSON.stringify(thing);
      return index === this.availabilityLostList.findIndex(obj => JSON.stringify(obj) === _thing);
    });
  }

  // Save grower data in database
  UpdateGrowerOrder() {
    this.checkDealerInventory();

    if (this.availabilityLostList.length > 0) {
      const title = 'Confirm';
      let rows = '';
      this.availabilityLostList.forEach(element => {
        rows += '<tr class="mat-row">';
        rows += '<td class="mat-cell">' + element.itemNumber + '</td>';
        rows += '<td class="mat-cell">' + element.itemDescription + '</td>';
        rows += '</tr>';
      });
      const message = `<p>Modifying the listed product(s) will result in reducing your dealer order. <br /> If you select cancel, the product(s) you intended to modify will not be changed.<br /></p>
            <div class="row">
                <div class="col-md-12 padding-r0">
                    <div class="tableContainer">
                        <table class="matTables mat-table">
                            <thead>
                                <tr class="mat-header-row">
                                    <th class="mat-header-cell">Item number</th>
                                    <th class="mat-header-cell">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${rows}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>`;

      // var title = "Warning";
      // var itemtable = "<br />";
      // itemtable += "<table><tr><td>Item Number</td><td>Description</td></tr>";
      // this.availabilityLostList.forEach(x => {
      //  itemtable += "<tr><td>" + x.itemNumber + "</ td> <td>" + x.itemDescription + "</ td></ tr>";
      // })
      // itemtable += "</table>";

      // var message = "<div class='row'> <div class='col-md-12'>Modifying the listed product(s) will result in reducing your dealer order.  If you have questions, please feel free to contact WinField United Customer Service 1.855.494.6343. <br /> If you select cancel, the products you modified will  be checked.<br />" + itemtable + "</div></div>";
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '680px',
        data: { title: title, htmlMessage: message, labelYes: 'OK to Continue', labelNo: 'Cancel', dialogType: 'confirm' }
      });

      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.updateGrowerOrderNew();
          this.decreasedItemList = [];
        }
        else {
          this.revertToPreviousState(false);
          const filteredData = this.growerOrderDS.data.filter(x => x.isSelected == true);
          if (filteredData && filteredData.length > 0) {
            this.selectedCount = filteredData.length;
            this.editToolKit = true;
          }
          this.decreasedItemList = [];
          // this.sliderModelService.close();
        }
      }));
    }
    else {
      this.updateGrowerOrderNew();
    }
  }

  updateGrowerOrderNew() {
    // reset scroll top
    $('#orderView').animate({
      scrollTop: 0
    }, 'slow');

    this.subscription.push(this.growerOrderService.validateAccountForB2BEnablement(this.AccountId).subscribe((result: any) => {
      if (result && result == true || result == 'true') {
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { hasChangeAdded: false });
      }
      else {
        if (this.selectedBillingType && this.selectedBillingType in (MasterConstants.BILLING_ADDRESS_TYPE)) {
          this.isBusy = true;
          if (this.validateOrder('')) // && this.validateTransactionQty('geu')
          {
            // reset common error msgs
            this.errorMsgs = new Array();
            this.GetErrorMsgs.emit(this.errorMsgs);
            this.loaderService.setLoaderStatus(true);
            const data = [];

            const filteredData = this.growerOrderDS.data.filter(x => x.deactivationType ? (x.deactivationType.trim().toLowerCase() !== 'suspend') : true);

            filteredData.forEach(item => {
              // var dd = item.desiredDeliveryDate.toString();
              // dd = dd.substring(0, 10);
              const dd = (new Date(item.desiredDeliveryDate)).toLocaleDateString('en-US').replace(/\u200E/g, '');
              data.push({
                growerOrderId: item.growerOrderID != null ? item.growerOrderID : 0,
                growerOrderItemId: item.growerOrderItemId,
                companyCode: this.headerCompany,
                cropYear: this.headerYear,
                growerGLN: item.growerGLN,
                growerGMK: item.growerGMK,
                dealerOrderNumber: item.dealerOrderNumber,
                growerOrderNumber: this.SelGrowerObj ? this.SelGrowerObj.orderID : item.growerOrderNumber,
                itemId: item.itemID,
                itemNumber: item.itemNumber,
                accountId: item.shipToAccount,
                quantity: item.geu,
                primaryQuantity: item.geu,
                transactionQty: item.geu,
                primaryUOM: item.primaryUOM,
                secondaryUOM: item.secondaryUOM,
                actionType: item.status,
                lineNumber: item.lineNumber,
                customerPO: item.customerPO,
                desiredDeliveryDate: dd,
                sellerID: item.sellerID,
                status: item.status,
                orderStatus: 'A',
                ChangeType: item.ChangeType,
                EmailTo: this.SelGrowerObj ? this.SelGrowerObj.EmailTo : '',
                isHybridVarietyPackageSize: item.IsHybridVarietyPackageSize || false,
                isReservationConversion: false
              });
            });

            // var validated;
            if (data) {
              this.subscription.push(this.growerOrderService.growerOrderAddUpdate(data).subscribe((result: any) => {
                if (result && result.growerOrderId != 0) {
                  this.checkedItems = [];
                  this.isUpdateAction = true;
                  // Clear any selected hybrid products when order is successfully updated
                  this.growerOrderService.clearSelectedHybridProducts();
                  this.router.navigate(['/orders/grower-order-detail', this.accountId, +result.growerOrderId]);
                }
                if (data['growerOrderId'] == 0) {
                  this.toastrService.success('Grower Order #' + result.orderNumber + ' saved successfully.');
                  // Also clear selected hybrid products on successful save
                  this.growerOrderService.clearSelectedHybridProducts();
                } else {
                  this.toastrService.success('Grower Order #' + result.orderNumber + ' updated successfully.');
                }
                this.loaderService.setLoaderStatus(false);
                this.editToolKit = false;
                this.isBusy = false;

                this.growerOrderDS.data.forEach(item => {
                  item.isSelected = false;
                });
                this.selectedCount = 0;
              }));
              this.isReadOnly = false;
            }
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          }
          else {
            this.showHideLineError(0);
            this.isBusy = false;
            this.isReadOnly = false;
            this.loaderService.setLoaderStatus(false);
          }
        }
        else {
          this.toastrService.warning('Account not eligible for Ordering.');
        }
      }
    }));
  }

  CancelGrowerOrder() {
    if (this.buttonType == 'add') {
      let accountNo = '0';
      if (this.accountId != 0) {
        accountNo = this.accountId.toString();
      }
      if (this.hasChangeAdded) {
        var title = 'Leave without saving?';
        var message = '';
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
        });

        this.subscription.push(dialogRef.afterClosed().subscribe(result => {
          // If user selected Yes
          if (result == true) {
            this.checkedItems = [];
            this.isUpdateAction = false;
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
            this.enableAddProduct = true;
            // Clear any selected hybrid products when user leaves without saving
            this.growerOrderService.clearSelectedHybridProducts();
            this.router.navigate(['/orders/grower-order-add', accountNo]);
          }
        }));
      }
      else {
        this.checkedItems = [];
        this.isUpdateAction = false;
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
        this.loaderService.setLoaderStatus(true);
        this.enableAddProduct = true;
        // Clear selected hybrid products before navigating away
        this.growerOrderService.clearSelectedHybridProducts();
        this.router.navigate(['/orders/grower-order-add', accountNo]);
        setTimeout(x => { this.loaderService.setLoaderStatus(false); }, 200);
      }
    }
    else {
      if (this.hasChangeAdded) {
        var title = 'Leave without saving?';
        var message = '';
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '480px',
          data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm' }
        });

        this.subscription.push(dialogRef.afterClosed().subscribe(result => {
          // If user selected Yes
          if (result == true) {
            this.revertToPreviousState(true);
            // User confirmed leaving without saving; clear selected hybrid products
            this.growerOrderService.clearSelectedHybridProducts();
          }
        }));
      }
      else {
        this.revertToPreviousState(true);
        this.loaderService.setLoaderStatus(true);
        // Clear selected hybrid products when canceling without unsaved changes
        this.growerOrderService.clearSelectedHybridProducts();
        setTimeout(x => { this.loaderService.setLoaderStatus(false); }, 200);
      }
    }
  }

  sellerSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Validate transaction quantity and show warning based on value
  validateTransactionQty(validategeu) {
    let isValidatedQty = true;
    let isValidatedDate = true;
    if (this.growerOrderDS.data && this.growerOrderDS.data.length > 0) {
      if (validategeu != '') {
        this.growerOrderDS.data.forEach(x => {
          x.lineErrors.errors = [];
          this.validateLineItem(x, '');
          if (x.geu <= 0 && x.growerOrderItemId == 0) {
            isValidatedQty = false;
            x.lineErrors.errors.push({ id: 'geu', error: 'Add quantity to the product line item.' });
            this.validateLineItem(x, '');
          }
          if (x.desiredDeliveryDate == null || x.desiredDeliveryDate == '') {
            isValidatedDate = false;
            x.lineErrors.errors.push({ id: 'desiredDeliveryDate', error: 'Desired Delivery date is required for product line item.' });
          }
        });
      }
    }
    return (isValidatedQty && isValidatedDate);
  }

  // validation on Add/Update product
  validateOrder(validateField) {
    let isValidated = true;
    if (this.growerOrderDS.data && this.growerOrderDS.data.length > 0) {
      isValidated = true;
      // TODO: Commented error handling to validate later
      this.growerOrderDS.data.forEach(x => {
        x = this.validateLineItem(x, '');
        if (x.lineErrors.errors.length > 0) {
          isValidated = false;
        }
      });
    }
    else {
      this.toastrService.warning('No Products added to place order');
    }
    return isValidated;
  }

  // Line item validation
  validateLineItem(item: any, validateField) {
    // item.lineErrors.errors = [];
    if (validateField != '') {
      switch (validateField) {
        case 'geu':
          if (item.geu < 0) {
            item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'geu');
            item.lineErrors.errors.push({ id: 'geu', error: 'Units should be greater than zero' });
          }
          else {
            item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'geu');
            this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
          }
          break;
        case 'desiredDeliveryDate':
          if (item.desiredDeliveryDate == null || item.desiredDeliveryDate == '') {
            item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'desiredDeliveryDate');
            item.lineErrors.errors.push({ id: 'desiredDeliveryDate', error: 'Desired Delivery date is required for product line item.' });
          }
          else {
            item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'desiredDeliveryDate');
            this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
          }
          break;
        case 'deactivationType':
          if (item.deactivationType && item.deactivationType.toLocaleLowerCase() === 'full' && item.isSelected) {
            item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deactivationType');
            item.lineErrors.errors.push({ id: 'deactivationType', error: 'This product is not eligible for transfer' });
          } else {
            item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'deactivationType');
            this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
          }
        default:
          break;
      }
    }
    else {
      if (item.geu <= 0 && item.growerOrderItemId == 0) {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'geu');
        item.lineErrors.errors.push({ id: 'geu', error: 'Units should be greater than zero' });
      }
      else {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'geu');
        this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      }
      if (item.desiredDeliveryDate == null || item.desiredDeliveryDate == '') {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'desiredDeliveryDate');
        item.lineErrors.errors.push({ id: 'desiredDeliveryDate', error: 'Desired Delivery date is required for product line item.' });
      }
      else {
        item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'desiredDeliveryDate');
        this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      }
    }

    if (item.lineErrors.errors.length > 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.lineErrors);
    }
    else {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }

    this.errorMsgs.sort(function (row1, row2) {
      return row1.rowId - row2.rowId;
    });
    this.GetErrorMsgs.emit(this.errorMsgs);

    return item;
  }

  validateItem(item: any) {
    if (this.growerOrderDataCopy) {
      this.growerOrderDataCopy.forEach(y => {
        if (y.rowId == item.rowId) {
          if (item.geu < y.geu) {
            item.showCutCancelOverWarning = item.cutCancelOverWarning;
          }
          else {
            item.showCutCancelOverWarning = false;
          }
        }
      });
    }
  }
  // To hide error on button click and show while validate
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Edit Region : End

  // Unsubscribe SliderModel Popup
  ngOnDestroy() {
    if (this.IsMobile) {
      this.commonService.setSeedOrderGrowerGMK(0);
      this.commonService.setSeedOrderDealerAccount(0);
    }
    this.growerOrderService.clearSelectedHybridProducts();
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  private getLineQuantity(item: any): number {
    const quantity = item?.geu;
    const parsedQuantity = Number(quantity);
    return Number.isFinite(parsedQuantity) ? parsedQuantity : 0;
  }

  isLineUnlicensed(item: any): boolean {
    return !!(item
      && (item.isUnlicensed === true)
      && !this.isLineDeletedFromGrid(item)
      && this.getLineQuantity(item) > 0);
  }

  private isLineDeletedFromGrid(item: any): boolean {
    return !!(item && (item.rowId === 0 || (item.growerOrderItemId > 0 && this.checkedItems[item.growerOrderItemId] !== undefined)));
  }

  private updateUnlicensedState(orderList: any[]): void {
    this.hasUnlicensedItems = Array.isArray(orderList) && orderList.some(x => this.isLineUnlicensed(x));
  }

  bindDataSource(orderList: any, isClone: boolean, isFisrtCopy: boolean) {
    if (orderList && orderList != null) {
      if (orderList.length > 0) {
        let rowId: Number = 0;
        orderList.forEach(x => {
          rowId = +rowId + 1;
          x.rowId = +rowId;
          if (x.lineErrors != undefined
            && x.lineErrors != null) {
            x.lineErrors = { 'rowId': x.rowId, 'errors': x.lineErrors.errors };
          }
          if (isClone) {
            x.lineErrors = { 'rowId': x.rowId, 'errors': [] };
          }
          x.cutCancelOverWarning = false;
          x.cutOverWarning = false;
          x.showCutCancelOverWarning = false;
          x.showCutOverWarning = false;
          x.isUnlicensed = x.isUnlicensed === true;
          if (x.cutCancelOverDate != null) {
            const currentDate = new Date();
            const cutCancelDate = new Date(x.cutCancelOverDate);
            cutCancelDate.setSeconds(cutCancelDate.getSeconds() + 86399);
            if (currentDate > cutCancelDate) {
              x.cutCancelOverWarning = true;
            }
          }
          if (x.cutOverDate != null) {
            const currentDate = new Date();
            const cutOverDate = new Date(x.cutOverDate);
            cutOverDate.setSeconds(cutOverDate.getSeconds() + 86399);
            if (currentDate > cutOverDate) {
              x.cutOverWarning = true;
            }
          }
          x.geu = this.commonService.getFormatedNumber(x.geu, false);
        });
      }

      this.growerOrderDS = new MatTableDataSource(orderList);
      this.updateUnlicensedState(this.growerOrderDS.data);
      if (this.growerOrderDS.data.length > 0) {
        this.disablecheckbox = false;
      }
      else {
        this.disablecheckbox = true;
      }
      this.growerOrderDS.filterPredicate = (data: any, filter: any) => {
        let maturity = 0;
        if (data.productNameFilter == null || data.productNameFilter == 'undefined') {
          data.productNameFilter = '';
        }
        if (data.technology == null || data.technology == 'undefined') {
          data.technology = '';
        }
        if (filter.TechnologyList != null && filter.TechnologyList != '') {
          var technologyFilter = filter.TechnologyList.trim().toLowerCase().split(',');
        }
        if (!this.isNumber(data.maturity)) {
          maturity = 0;
        }
        else {
          maturity = data.maturity;
        }
        if ((filter.ProductNameFilter == null || (data.productNameFilter.toLowerCase().indexOf(filter.ProductNameFilter.toLowerCase()) > -1))
          && (filter.MarketingBrandList.length == 0 || (filter.MarketingBrandList.indexOf(data.marketingBrand) > -1))
          && (filter.PackageSizeList.length == 0 || (filter.PackageSizeList.indexOf(data.packageSize) > -1))
          && (filter.TechnologyList == null || filter.TechnologyList == '' || (technologyFilter.find(a => data.technology.trim().toLowerCase().includes(a))))
          && (filter.TreatmentList.length == 0 || (filter.TreatmentList.indexOf(data.treatment) > -1))
          && (filter.SeedSizeList.length == 0 || (filter.SeedSizeList.indexOf(data.seedSize) > -1))
          && (filter.ProductLineList.length == 0 || (filter.ProductLineList.indexOf(data.productLine) > -1))
          && ((filter.MaturityMin == null && (maturity == null))
            || (filter.MaturityMin == null && (maturity != null))
            || (filter.MaturityMin == null && (filter.MaturityMax != null))
            || (filter.MaturityMin != null && (filter.MaturityMax == null))
            || ((filter.MaturityMin != null && filter.MaturityMax != null) && maturity != null && +maturity >= +filter.MaturityMin))
          && ((filter.MaturityMax == null && (maturity == null))
            || (filter.MaturityMax == null && (maturity != null))
            || (filter.MaturityMin == null && (filter.MaturityMax != null))
            || (filter.MaturityMin != null && (filter.MaturityMax == null))
            || ((filter.MaturityMax != null && filter.MaturityMin != null) && maturity != null && +maturity <= +filter.MaturityMax))
          && (this.checkedItems.length == 0 || this.checkedItems[data.growerOrderItemId] == undefined)) {
          if (data.isProductDeactivated === false
            || (data.deactivationType == null || data.deactivationType.trim().toLowerCase() != 'suspend')) {
            this.filterGrowerOrderDSitems.push(data);
          }
          this.filteredDataCount = this.filteredDataCount + 1;
          this.bagCount = this.bagCount + parseFloat(data.geu);

          return true;
        }
        else {
          return false;
        }
      };

      this.applyFilterData(this.productFilters);
      // created deep copy
      if (isClone) {
        this.growerOrderListCopy = JSON.parse(JSON.stringify(orderList));
      }

      if (isFisrtCopy) {
        this.growerOrderDataCopy = JSON.parse(JSON.stringify(orderList));
      }
    }
  }

  // To revert changes
  RevertToPrevious(element: any, isSingleLine) {
    if (element && element != null && this.growerOrderListCopy.length > 0 && this.growerOrderDS.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = JSON.parse(JSON.stringify(this.growerOrderListCopy)).filter(x => x.rowId == element.rowId)[0];

        // get current object index
        const currentLineIndex = this.growerOrderDS.data.findIndex(x => x.rowId == element.rowId);

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.growerOrderDS.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));

          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != oldLineValue.rowId);

          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.rowId);
          this.bindDataSource(this.growerOrderDS.data, false, false);

          // if (this.errorMsgs.length == 1) {
          //  this.errorMsgs = new Array();
          //  this.GetErrorMsgs.emit(this.errorMsgs);
          // }
          this.GetErrorMsgs.emit(this.errorMsgs);
        }
      }
      else {
        // replace whole object
        this.growerOrderDS.data = JSON.parse(JSON.stringify(this.growerOrderListCopy));

        // To hide all errors after revert all changes
        this.growerOrderDS.data.forEach(x => {
          this.showHideLineError(x.rowId);
        });
        this.bindDataSource(this.growerOrderDS.data, false, false);
        // To hide common error msg
        this.errorMsgs = new Array();
        this.GetErrorMsgs.emit(this.errorMsgs);
      }
    }
  }

  ValidateSaveButton() {
    if (this.SelGrowerObj == undefined || (this.SelGrowerObj != undefined && this.SelGrowerObj.growerOrderId === 0)) {
      this.buttonType = 'add';
    }
    else {
      this.buttonType = 'edit';
    }
  }

  validateSelectedCount(element) {
    if (element.isSelected != true && !this.accessTypeMode) {
      element.isSelected = true;
      this.activeEditToolKit(true);
    }
  }

  isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  }

  // to show hide product deactivation info block
  blockHideShow(id: number, flag: boolean) {
    if (flag) {
      $('#sub_' + id).addClass('showHide');
      $('#main_' + id).addClass('prod-unavail-info-hover');
    }
    else {
      $('#sub_' + id).removeClass('showHide');
      $('#main_' + id).removeClass('prod-unavail-info-hover');
    }
  }

  backToOrder() {
    this.commonService.setSeedOrderTabIndex(0);
    let gmk = 0;
    let dealerAc = 0;
    if (this.growerGMK && this.growerGMK > 0) {
      gmk = this.growerGMK;
    }
    if (this.selectedDealerAccount && this.selectedDealerAccount > 0) {
      dealerAc = this.selectedDealerAccount;
    }

    //this.router.navigate(['/landing-data?growerGMK=' + gmk + '&dealerAccount=' + dealerAc]);
    this.router.navigate(['/landing-data'], {
      queryParams: {
        growerGMK: gmk,
        dealerAccount: dealerAc
      }
    });
  }

  isInWebView(): boolean {
    const ua = navigator.userAgent || '';

    // React Native WebView
    if ((window as any).ReactNativeWebView) return true;

    // iOS WebView: AppleWebKit but NOT Safari
    const isIOS = /iPhone|iPod|iPad/i.test(ua);
    const isIOSWebView = isIOS && /AppleWebKit/.test(ua) && !/Safari/.test(ua);

    // Android WebView: look for 'wv' or no 'Chrome' version string
    const isAndroidWebView = /; wv/.test(ua) || (/Android/.test(ua) && !/Chrome\/\d/.test(ua));

    return isIOSWebView || isAndroidWebView;
  }
}
